export class CategoryItem
{
    Id: number;
    Name: string;
    Description: string;
    MemberTypeIds: number[] = [];

    constructor(json: object = null)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }
    }
}
